import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ContratoComponent } from './contrato/contrato.component';
import { ContratosComponent } from './contratos/contratos.component';
import { OrdemServicoComponent } from './ordem-servico/ordem-servico.component';
import { EquipeComponent } from './equipe/equipe.component';
import { AssinantesComponent } from './assinantes/assinantes.component';
import { AssinanteComponent } from './assinante/assinante.component';
import { PessoaComponent } from './pessoa/pessoa.component';
import { PaisComponent } from './pais/pais.component';
import { EstadoComponent } from './estado/estado.component';
import { EnderecoLocalTipoComponent } from './endereco-local-tipo/endereco-local-tipo.component';
import { LocalidadeComponent } from './localidade/localidade.component';
import { LogradouroComponent } from './logradouro/logradouro.component';
import { LogradouroCepComponent } from './logradouro-cep/logradouro-cep.component';
import { BairroComponent } from './bairro/bairro.component';
import { FornecedorComponent } from './fornecedor/fornecedor.component';
import { FilialComponent } from './filial/filial.component';
import { EmpresaComponent } from './empresa/empresa.component';
import { TecnicoComponent } from './tecnico/tecnico.component';
import { UsuarioSistemaComponent } from './usuario-sistema/usuario-sistema.component';
import { UsuariosSistemaComponent } from './usuarios-sistema/usuarios-sistema.component';
import { ProdutoComponent } from './produto/produto.component';
import { FuncaoEquipamentoComponent } from './funcao-equipamento/funcao-equipamento.component';
import { PromocaoComponent } from './promocao/promocao.component';
import { ProdutoSegmentoComponent } from './produto-segmento/produto-segmento.component';
import { ProdutoPromocaoComponent } from './produto-promocao/produto-promocao.component';
import { ProdutoPacoteComponent } from './produto-pacote/produto-pacote.component';
import { ItemComponent } from './item/item.component';
import { ItemSerieComponent } from './item-serie/item-serie.component';
import { ProtocoloAtendimentoTipoComponent } from './protocolo-atendimento-tipo/protocolo-atendimento-tipo.component';
import { ProtocoloTipoComponent } from './protocolo-tipo/protocolo-tipo.component';
import { ServicoComponent } from './servico/servico.component';
import { ProtocoloAssuntoComponent } from './protocolo-assunto/protocolo-assunto.component';
import { ProtocoloMotivoComponent } from './protocolo-motivo/protocolo-motivo.component';
import { OrdensServicoComponent } from './ordens-servico/ordens-servico.component';
import { ProtocolosComponent } from './protocolos/protocolos.component';
import { ProtocoloComponent } from './protocolo/protocolo.component';
import { ClienteTipoComponent } from './cliente-tipo/cliente-tipo.component';
import { AutorizacaoTipoComponent } from './autorizacao-tipo/autorizacao-tipo.component';
import { LinhaTelefonicaComponent } from './linha-telefonica/linha-telefonica.component';
import { OperadoraComponent } from './operadora/operadora.component';
import { MotivoInativacaoComponent } from './motivo-inativacao/motivo-inativacao.component';
import { MotivoCancelamentoComponent } from './motivo-cancelamento/motivo-cancelamento.component';
import { BancoAgenciaComponent } from './banco-agencia/banco-agencia.component';
import { BancoComponent } from './banco/banco.component';
import { UsuarioGrupoComponent } from './usuario-grupo/usuario-grupo.component';
import { ReligiaoComponent } from './religiao/religiao.component';
import { ProfissaoComponent } from './profissao/profissao.component';
import { CobrancaTipoComponent } from './cobranca-tipo/cobranca-tipo.component';
import { FabricanteComponent } from './fabricante/fabricante.component';
import { CanalComponent } from './canal/canal.component';
import { AutorizadorGuard } from './autorizador.guard';
import { LoginComponent } from './login/login.component';
import { PermissaoNegadaComponent } from './permissao-negada/permissao-negada.component';
import { MapaTecnicoComponent } from './tecnico/mapa-tecnico/mapa-tecnico.component';
import { EnderecoWsCepComponent } from './endereco-ws-cep/endereco-ws-cep.component';

export const ROUTES: Routes = [
    {path: '', component: HomeComponent, canActivate: [AutorizadorGuard]},

    // CONTRATO
    {path: 'contrato', component: ContratoComponent, canActivate: [AutorizadorGuard]},
    {path: 'contrato/:id', component: ContratoComponent, canActivate: [AutorizadorGuard]},
    {path: 'contratos', component: ContratosComponent, canActivate: [AutorizadorGuard]},
    {path: 'cliente-tipo', component: ClienteTipoComponent, canActivate: [AutorizadorGuard]},
    {path: 'autorizacao-tipo', component: AutorizacaoTipoComponent, canActivate: [AutorizadorGuard]},
    {path: 'linha-telefonica', component: LinhaTelefonicaComponent, canActivate: [AutorizadorGuard]},
    {path: 'operadora', component: OperadoraComponent, canActivate: [AutorizadorGuard]},
    {path: 'cobranca-tipo', component: CobrancaTipoComponent, canActivate: [AutorizadorGuard]},

    // PESSOA
    {path: 'pessoa', component: PessoaComponent, canActivate: [AutorizadorGuard]},
    {path: 'assinante', component: AssinanteComponent, canActivate: [AutorizadorGuard]},
    {path: 'assinante/:id', component: AssinanteComponent, canActivate: [AutorizadorGuard]},
    {path: 'assinantes', component: AssinantesComponent, canActivate: [AutorizadorGuard]},
    {path: 'pais', component: PaisComponent, canActivate: [AutorizadorGuard]},
    {path: 'estado', component: EstadoComponent, canActivate: [AutorizadorGuard]},
    {path: 'endereco-local-tipo', component: EnderecoLocalTipoComponent, canActivate: [AutorizadorGuard]},
    {path: 'localidade', component: LocalidadeComponent, canActivate: [AutorizadorGuard]},
    {path: 'logradouro', component: LogradouroComponent, canActivate: [AutorizadorGuard]},
    {path: 'logradouro-cep', component: LogradouroCepComponent, canActivate: [AutorizadorGuard]},
    {path: 'bairro', component: BairroComponent, canActivate: [AutorizadorGuard]},
    {path: 'empresa', component: EmpresaComponent, canActivate: [AutorizadorGuard]},
    {path: 'filial', component: FilialComponent, canActivate: [AutorizadorGuard]},
    {path: 'fornecedor', component: FornecedorComponent, canActivate: [AutorizadorGuard]},
    {path: 'fabricante', component: FabricanteComponent, canActivate: [AutorizadorGuard]},
    {path: 'equipe', component: EquipeComponent, canActivate: [AutorizadorGuard]},
    {path: 'tecnico', component: TecnicoComponent, canActivate: [AutorizadorGuard]},
    {path: 'tecnico/mapa-tecnico', component: MapaTecnicoComponent, canActivate: [AutorizadorGuard]},
    {path: 'tecnico/mapa-tecnico/:idTecnico', component: MapaTecnicoComponent, canActivate: [AutorizadorGuard]},
    {path: 'usuario-sistema', component: UsuarioSistemaComponent, canActivate: [AutorizadorGuard]},
    {path: 'usuario-sistema/:id', component: UsuarioSistemaComponent, canActivate: [AutorizadorGuard]},
    {path: 'usuarios-sistema', component: UsuariosSistemaComponent, canActivate: [AutorizadorGuard]},
    {path: 'banco-agencia', component: BancoAgenciaComponent, canActivate: [AutorizadorGuard]},
    {path: 'banco', component: BancoComponent, canActivate: [AutorizadorGuard]},
    {path: 'usuario-grupo', component: UsuarioGrupoComponent, canActivate: [AutorizadorGuard]},
    {path: 'religiao', component: ReligiaoComponent, canActivate: [AutorizadorGuard]},
    {path: 'profissao', component: ProfissaoComponent, canActivate: [AutorizadorGuard]},

    // PRODUTO
    {path: 'produto', component: ProdutoComponent, canActivate: [AutorizadorGuard]},
    {path: 'funcao-equipamento', component: FuncaoEquipamentoComponent, canActivate: [AutorizadorGuard]},
    {path: 'produto-segmento', component: ProdutoSegmentoComponent, canActivate: [AutorizadorGuard]},
    {path: 'promocao', component: PromocaoComponent, canActivate: [AutorizadorGuard]},
    {path: 'produto-promocao', component: ProdutoPromocaoComponent, canActivate: [AutorizadorGuard]},
    {path: 'produto-pacote', component: ProdutoPacoteComponent, canActivate: [AutorizadorGuard]},
    {path: 'canal', component: CanalComponent, canActivate: [AutorizadorGuard]},

    // ITEM
    {path: 'item', component: ItemComponent, canActivate: [AutorizadorGuard]},
    {path: 'item-serie', component: ItemSerieComponent, canActivate: [AutorizadorGuard]},
    {path: 'motivo-inativacao', component: MotivoInativacaoComponent, canActivate: [AutorizadorGuard]},

    // ATENDIMENTO
    {path: 'protocolo-atendimento-tipo', component: ProtocoloAtendimentoTipoComponent, canActivate: [AutorizadorGuard]},
    {path: 'protocolo-assunto', component: ProtocoloAssuntoComponent, canActivate: [AutorizadorGuard]},
    {path: 'protocolo-tipo', component: ProtocoloTipoComponent, canActivate: [AutorizadorGuard]},
    {path: 'protocolo-motivo', component: ProtocoloMotivoComponent, canActivate: [AutorizadorGuard]},
    {path: 'protocolo', component: ProtocoloComponent, canActivate: [AutorizadorGuard]},
    {path: 'protocolo/:id', component: ProtocoloComponent, canActivate: [AutorizadorGuard]},
    {path: 'protocolos', component: ProtocolosComponent, canActivate: [AutorizadorGuard]},

    // OS
    {path: 'servico', component: ServicoComponent, canActivate: [AutorizadorGuard]},
    {path: 'ordens-servico', component: OrdensServicoComponent, canActivate: [AutorizadorGuard]},
    {path: 'ordem-servico', component: OrdemServicoComponent, canActivate: [AutorizadorGuard]},
    {path: 'ordem-servico/:id', component: OrdemServicoComponent, canActivate: [AutorizadorGuard]},
    {path: 'motivo-cancelamento', component: MotivoCancelamentoComponent, canActivate: [AutorizadorGuard]},

    // login
    {path: 'login', component: LoginComponent},
    {path: 'permissao-negada', component: PermissaoNegadaComponent},

    // Outros
    {path: 'endereco-ws-cep', component: EnderecoWsCepComponent, canActivate: [AutorizadorGuard]}

];



// WEBPACK FOOTER //
// ./src/app/app.routes.ts